import { render, staticRenderFns } from "./Kbli.vue?vue&type=template&id=15d61eac&"
import script from "./Kbli.vue?vue&type=script&lang=js&"
export * from "./Kbli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports